export default __webpack_public_path__ + "static/media/face2.ede0be20.jpg";